import { createFilePath } from "@/common";
import { FileList } from "@/components";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import React from "react";

const NAME = "feedback";

const App = () => {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[{ title = "反馈详情", show, hide, width = 800, vo = { files: [] } }]] = useWatchState(["modal." + NAME])

    console.log(UPLOAD_SERVER_HOST)

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <div className="child-top-sm">
                <p>
                    <span className="bold dark-title">姓名：</span>
                    <span className="dark-second">{vo.name}</span>
                </p>
                <p>
                    <span className="bold dark-title">单位：</span>
                    <span className="dark-second">{vo.orgName}</span>
                </p>
                <p>
                    <span className="bold dark-title">联系电话：</span>
                    <span className="dark-second">{vo.phone}</span>
                </p>
                <p>
                    <span className="bold dark-title">反馈意见：</span>
                    <span className="dark-second">{vo.remark}</span>
                </p>
                <p>
                    <span className="bold dark-title">附件：</span>
                    <div className="p-sm">
                        <FileList data={vo.files.map(o => ({ ...o, url: createFilePath(o.url, UPLOAD_SERVER_HOST) }))} />
                    </div>
                </p>
            </div>
        </Modal>
    );
}

export default App;